export default function deepClone<T>(input: T): T {
	return structuredClone(input);
}
